import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-collapse"
export default class extends Controller {
  connect() {
    const collapsers = document.querySelectorAll('.collapser');
    collapsers.forEach(collapser => {
      collapser.addEventListener('click', function() {
        if (collapser.classList.contains('collapsed')) {
          collapser.innerText = '+'
        } else {
          collapser.innerText = '-'
        }
      });
    });
  }
}
